import { Fragment, useEffect, useState } from 'react'
import SelectionBox from '../../../../widgets/SelectionBox';
import { fetchDataFromApi, postDataToTheServer } from '../../../../widgets/api';
import AppURL from '../../../../widgets/AppURL';
import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import { ToastError, ToastSuccess } from '../../../../widgets/ToastMessage';
import { AcGeneralLedgOptions, FiscalYearOptions, SubLedgersOptions } from '../../../../widgets/Options';
import ComponentHeading from '../../../../widgets/ComponentHeading';
import { FaAddressCard } from 'react-icons/fa6';
import InputTextBox from '../../../../widgets/InputTextBox';
import { SaveBtn } from '../../../../widgets/AppBtn';

const YearlyBudgetFormView = ({ onGeneralLedger, FetchData }) => {
    const AcGeneralLedgOption = AcGeneralLedgOptions(onGeneralLedger?.data);
    const [on_ledger_list, setOnLedgerList] = useState([]);
    const SubLedgerOption = SubLedgersOptions(on_ledger_list?.data?.sub_ledger);

    const initialValues = {
        glid: "",
        sglsn: "",
        estimated_amount: "",
        fiscal_year_id: "",
        real_amount: 0,
        difference_amount: 0
    };

    const { values, handleSubmit, handleBlur, setFieldValue, handleChange, errors, touched } =
        useFormik({
            initialValues,
            enableReinitialize: true,
            onSubmit: async (values, action) => {
                const formData = new FormData();
                formData.append("fiscal_year_id", values.fiscal_year_id);
                formData.append("estimated_amount", values.estimated_amount);
                formData.append("real_amount", 0);
                formData.append("difference_amount", 0);
                formData.append("sglsn", values?.sglsn);

                try {
                    await postDataToTheServer(AppURL.AccountsURL + "account-yearly-budget-create-list-view/", formData).then((res) => {
                        if (res?.status === 201) {
                            ToastSuccess(res?.message);
                            setFieldValue("estimated_amount", "");
                            FetchData();
                        }
                        if (res?.status === 400 && res?.message?.non_field_errors) {
                            ToastError("Fee Already Assigned");
                        }
                    });
                } catch (error) {
                    console.log(error);
                }
            }
        });
    const fetchDataList = async () => {
        try {
            if (values?.glid) {
                const res = await fetchDataFromApi(
                    AppURL.AccountsURL +
                    "account-general-ledg-list-sub-ledg-list-view/?glid=" +
                    values?.glid
                );
                setOnLedgerList(res);
            }
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        fetchDataList()
    }, [values?.glid])

    const [onManageFiscalYear, setOnFiscalYear] = useState([]);
    const fetchDataBalanceSheet = async () => {
        try {
            await fetchDataFromApi(AppURL.AccountsURL + "account-fiscal-year-date-list-view/").then((res) => {
                setOnFiscalYear(res);
            });
        } catch (error) {
            console.log(error);
        }
    }
    const FiscalYearOption = FiscalYearOptions(onManageFiscalYear?.data);

    useEffect(() => {
        fetchDataBalanceSheet();
    }, []);

    return (
        <Fragment>
            <div className="bg-white p-4 border dark:border-slate800 rounded-md dark:bg-slate800">
                <ComponentHeading
                    icon={FaAddressCard}
                    label={"Voucher Information"}
                />
                <Grid container spacing={2}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <SelectionBox name="fiscal_year_id" label="Fiscal Year" options={FiscalYearOption} value={values.fiscal_year_id} optionSelect={(fieldName, data) => {
                            setFieldValue(fieldName, data?.value);
                        }} handleBlur={handleBlur}
                            touched={touched.fiscal_year_id} errors={errors.fiscal_year_id} required={true} />
                    </Grid>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <SelectionBox
                            label={"General Ledger"}
                            optionSelect={(fieldName, data) => {
                                setFieldValue(fieldName, data?.value);
                            }}
                            name="glid"
                            focus={true}
                            value={values?.glid}
                            errors={errors.glid}
                            options={AcGeneralLedgOption}
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <SelectionBox
                            label={"Sub Ledger"}
                            focus={true}
                            required={true}
                            name="sglsn"
                            optionSelect={(fieldName, data) => {
                                setFieldValue(fieldName, data.value);
                            }}
                            value={values.sglsn}
                            options={SubLedgerOption}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <InputTextBox type="number" label={"Estimated Amount"} handleChange={handleChange} name="estimated_amount" errors={errors?.estimated_amount} value={values.estimated_amount}
                            required={true} />
                    </Grid>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className='flex justify-end mt-3'>
                            <SaveBtn type="submit" onClick={handleSubmit} />
                        </div>
                    </Grid>
                </Grid>
            </div>
        </Fragment>
    )
}

export default YearlyBudgetFormView
